export default class NavPage {
  constructor(page) {
    this.target = { dataset: { nav: page } };
  }
}
